import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { publicApi } from '../services/api';

const CONSENT_KEY = 'mordeczka_cookie_consent';
const VISITOR_KEY = 'mordeczka_anonymous_visitor';

function getVisitorId(): string {
  let visitorId = localStorage.getItem(VISITOR_KEY);
  if (!visitorId) {
    visitorId = crypto.randomUUID();
    localStorage.setItem(VISITOR_KEY, visitorId);
  }
  return visitorId;
}

export function TrafficTracker() {
  const location = useLocation();

  useEffect(() => {
    const track = () => {
      if (localStorage.getItem(CONSENT_KEY) !== 'accepted') return;
      void publicApi.trackPageView(
        `${location.pathname}${location.search}`,
        getVisitorId(),
      );
    };

    track();
    window.addEventListener('mordeczka:analytics-consent', track);
    return () => window.removeEventListener('mordeczka:analytics-consent', track);
  }, [location.pathname, location.search]);

  return null;
}
